
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.0002 4C15.5502 4 16.0002 4.45 16.0002 5C16.0002 5.55 15.5502 6 15.0002 6C14.4502 6 14.0002 5.55 14.0002 5C14.0002 4.45 14.4502 4 15.0002 4ZM14.0002 7C14.5502 7 15.0002 7.45 15.0002 8C15.0002 8.55 14.5502 9 14.0002 9C13.4502 9 13.0002 8.55 13.0002 8C13.0002 7.45 13.4502 7 14.0002 7ZM12.0002 4C12.5502 4 13.0002 4.45 13.0002 5C13.0002 5.55 12.5502 6 12.0002 6C11.4502 6 11.0002 5.55 11.0002 5C11.0002 4.45 11.4502 4 12.0002 4ZM17.0002 9C16.4502 9 16.0002 8.55 16.0002 8C16.0002 7.45 16.4502 7 17.0002 7C17.5502 7 18.0002 7.45 18.0002 8C18.0002 8.55 17.5502 9 17.0002 9ZM18.0002 6C17.4502 6 17.0002 5.55 17.0002 5C17.0002 4.45 17.4502 4 18.0002 4C18.5502 4 19.0002 4.45 19.0002 5C19.0002 5.55 18.5502 6 18.0002 6ZM20.0002 9C19.4502 9 19.0002 8.55 19.0002 8C19.0002 7.45 19.4502 7 20.0002 7C20.5502 7 21.0002 7.45 21.0002 8C21.0002 8.55 20.5502 9 20.0002 9ZM21.0002 6C20.4502 6 20.0002 5.55 20.0002 5C20.0002 4.45 20.4502 4 21.0002 4C21.5502 4 22.0002 4.45 22.0002 5C22.0002 5.55 21.5502 6 21.0002 6ZM14.6202 14.38L12.1002 16.9C9.60017 15.47 7.53017 13.4 6.10017 10.9L8.62017 8.38C8.86017 8.14 8.96017 7.8 8.90017 7.48L8.16017 3.8C8.07017 3.34 7.66017 3 7.18017 3H3.03017C2.47017 3 2.00017 3.47 2.03017 4.03C2.20017 6.92 3.05017 9.63 4.43017 12C6.01017 14.73 8.28017 16.99 11.0002 18.57C13.3702 19.94 16.0802 20.8 18.9702 20.97C19.5302 21 20.0002 20.53 20.0002 19.97V15.82C20.0002 15.34 19.6602 14.93 19.2002 14.84L15.5302 14.11C15.2002 14.04 14.8602 14.14 14.6202 14.38ZM15.0002 10C15.5502 10 16.0002 10.45 16.0002 11C16.0002 11.55 15.5502 12 15.0002 12C14.4502 12 14.0002 11.55 14.0002 11C14.0002 10.45 14.4502 10 15.0002 10ZM12.0002 10C12.5502 10 13.0002 10.45 13.0002 11C13.0002 11.55 12.5502 12 12.0002 12C11.4502 12 11.0002 11.55 11.0002 11C11.0002 10.45 11.4502 10 12.0002 10ZM18.0002 12C17.4502 12 17.0002 11.55 17.0002 11C17.0002 10.45 17.4502 10 18.0002 10C18.5502 10 19.0002 10.45 19.0002 11C19.0002 11.55 18.5502 12 18.0002 12ZM21.0002 12C20.4502 12 20.0002 11.55 20.0002 11C20.0002 10.45 20.4502 10 21.0002 10C21.5502 10 22.0002 10.45 22.0002 11C22.0002 11.55 21.5502 12 21.0002 12Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-tty`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTty

    ```js
    <b-new-b-icon-tty />
    ```
</docs>


